const selectors = {
  token: (state) => state.auth.token,
  roles: (state) => state.auth.roles,
  loginStatus: (state) => state.auth.loginStatus,
  shouldAuthenticate: (state) => state.auth.shouldAuthenticate,
};

export { selectors };
